import _ from "lodash";
import React, { PureComponent } from "react";
import classes from "./TagResource.scss";

import ScreenPanel from "../../ScreenPanel";
import { connect } from "react-redux";

import { graphql, compose } from "lib/apolloClient";

import {
  getResourceBucketQuery,
  getOrganizationAssessmentsQuery,
} from "Post/modules/PostQuery";
import I18nHOC from "UIComponents/I18nHOC";

import { updatePost } from "Post/modules/PostModule";
import { getFieldUids } from "modules/TaggableElementsUtils";

import moment from "moment";
import ResourceList from "./ResourceList";
import { Button, SearchInput } from "@toddle-edu/ds-web";
import { checkScrollAtBottom } from "Utils";
import { CURRICULUM_TYPE_PYP } from "Constants/stringConstants";
import { getCurrentAcademicYear } from "modules/CommonSelectors";

const styles = {
  titleTextStyle: {
    fontSize: "1.8rem",
    alignItems: "center",
  },
  titleContainerStyle: { marginTop: "32px" },
  containerStyle: { padding: "0 32px" },
  footerContainerStyle: { padding: "0px" },
};

const FooterComponent = React.memo(props => {
  const { onNextClick, isDisabled, onBackClick, t } = props;
  return (
    <div className={classes.footerButtonContainer}>
      <Button
        size={"large"}
        onClick={onBackClick}
        variant="outlined-subtle"
        style={{ marginRight: "12px" }}
        testId={"journal-postcreation-taglearninggoals-le-previous"}
      >
        {t("common:previous")}
      </Button>
    </div>
  );
});

FooterComponent.displayName = "FooterComponent";

class TagResource extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      refreshing: false,
      resourceId: props.resourceId,
      resourceType: props.resourceType,
      isResourceSkipped: props.isResourceSkipped,
      searchText: "",
    };
  }

  onNextClick = () => {
    const {
      screenPanelProps: {
        goToNextScreen,
        postDetails: {
          isResourceSkipped: propIsResourceSkipped,
          resourceItem: propResourceItem,
          elementPYP: propElementPYP,
          originalElementPYP = undefined,
          originalResourceItem = {},
        },
      },
      resources,
    } = this.props;

    const { resourceId, isResourceSkipped } = this.state;
    const resourceItem = _.find(resources, item => item.id == resourceId);

    //first check if resourceItem exists and is equal
    let updatedElementPYP = [];

    if (isResourceSkipped) {
      if (propIsResourceSkipped) {
        updatedElementPYP = _.cloneDeep(propElementPYP);
      } else {
        updatedElementPYP = undefined;
      }
    } else {
      if (
        propResourceItem == undefined ||
        (resourceItem != undefined &&
          (resourceItem.id != propResourceItem.id ||
            resourceItem.type != propResourceItem.type))
      ) {
        updatedElementPYP = undefined;
      } else {
        updatedElementPYP = _.cloneDeep(propElementPYP);
      }
    }

    this.props.updatePost({
      elementPYP: _.isEqual(
        _.get(resourceItem, "id", null),
        _.get(originalResourceItem, "id", null)
      )
        ? originalElementPYP
        : updatedElementPYP,
      resourceItem: resourceItem,
      resourceType: _.get(resourceItem, "type", "ASSESSMENT"),
      isResourceSkipped,
      unitPlan: _.find(
        _.get(this.props, "courseUnitPlans", []),
        unit => unit?.id == _.get(resourceItem, "unitPlan.id", null)
      ),
    });
    goToNextScreen();
  };

  skipResource = () => {
    this.setState({
      isResourceSkipped: !this.state.isResourceSkipped,
      resourceId: null,
      resourceType: null,
    });
  };

  onResourceClicked = resource => {
    const { resourceId } = this.state;
    this.setState({
      resourceId: resource.id,
      resourceType: resource.type,
      isResourceSkipped: resource.id == resourceId,
    });
    setTimeout(() => this.onNextClick());
  };

  handleScroll = e => {
    const containerDiv = e.target;
    const {
      hasNextPage,
      isLoading,
      loadMoreAssessments,
      selectedUnitPlan,
    } = this.props;
    if (
      containerDiv &&
      hasNextPage &&
      isLoading == false &&
      checkScrollAtBottom(containerDiv) &&
      _.size(selectedUnitPlan, 0) > 0
    ) {
      loadMoreAssessments();
    }
  };

  render() {
    const {
      screenPanelProps,
      resources,
      isLoading,
      isData,
      t,
      assessmentCount,
      leCount,
      searchText,
      curriculumProgramType,
      unitPlanOptions,
      selectedUnitPlan,
      onUnitPlanFilterChanged,
      networkStatus,
    } = this.props;

    const { isResourceSkipped, resourceType, resourceId } = this.state;
    const modalHeaderTitle = "journal:select_learning_experience";
    const searchPlaceholder =
      curriculumProgramType === CURRICULUM_TYPE_PYP
        ? "journal:select_learning_experience"
        : "journal:search_for_le_and_assessments";

    const unitPlanOptionsLength = _.get(unitPlanOptions, "length", 0);

    return (
      <ScreenPanel
        onScroll={this.handleScroll}
        {...screenPanelProps}
        showBack={false}
        titleTextStyle={styles.titleTextStyle}
        footerComponent={
          <FooterComponent
            t={t}
            isDisabled={!isResourceSkipped && !resourceId}
            onNextClick={this.onNextClick}
            onBackClick={
              !_.isUndefined(screenPanelProps?.goToPreviousScreen) &&
              screenPanelProps?.goToPreviousScreen
            }
          />
        }
        showCustomHeaderIcon={false}
        containerStyle={styles.containerStyle}
        titleContainerStyle={styles.titleContainerStyle}
        modalHeaderTitle={t(modalHeaderTitle)}
        showNewDesign={true}
        footerContainerStyle={styles.footerContainerStyle}
        showNewFooter={true}
      >
        <div className={classes.container} onScroll={this.handleScroll}>
          {(isData || !_.isEmpty(_.get(this.props, "searchText", ""))) && (
            <div className={classes.filterContainer}>
              <SearchInput
                value={_.get(this.props, "searchText", "")}
                placeholder={t(searchPlaceholder)}
                onChange={this.props.updateSearchText}
                size={"large"}
                testId={"journal-postcreation-taglearningexperience"}
              />
            </div>
          )}
          <ResourceList
            isLoading={isLoading}
            isData={isData}
            resources={resources}
            searchText={searchText}
            selectedUnitPlan={selectedUnitPlan}
            unitPlanOptionsLength={unitPlanOptionsLength}
            resourceId={resourceId}
            resourceType={resourceType}
            isResourceSkipped={isResourceSkipped}
            onResourceSkipClicked={this.skipResource}
            onItemClicked={this.onResourceClicked}
            showLoaderBar={false}
            curriculumProgramType={curriculumProgramType}
            networkStatus={networkStatus}
          />
        </div>
      </ScreenPanel>
    );
  }
}

const mapActionCreators = {
  updatePost,
};

const groupType = ["LEARNING_ENGAGEMENT", "ASSESSMENT"];

const mapStateToProps = (state, ownProps) => {
  const organizationId = state.login.userInfo.org_id;
  const courseId = state.teacher.selected_class.selected_course;
  const {
    unitPlan,
    resourceItem = {},
    resourceType,
    attachments,
    isResourceSkipped,
    elementPYP,
    courseUnitPlans = [],
  } = state.post.postDetails;
  const dateOfToday = moment().format("YYYY-MM-DD");
  const currentAcademicYear = getCurrentAcademicYear({
    organizationId: organizationId,
  });
  const startDate = moment(_.get(currentAcademicYear, "startDate", "")).format(
    "YYYY-MM-DD"
  );
  const endDate = moment(_.get(currentAcademicYear, "endDate", "")).format(
    "YYYY-MM-DD"
  );

  const unitPlanOptions = _.map(courseUnitPlans, unit => {
    return {
      label: _.get(unit, "title.value", ""),
      value: _.get(unit, "id", undefined),
    };
  });

  const courseUnitPlansIds = _.map(courseUnitPlans, unit =>
    _.get(unit, "id", "")
  );

  const curriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );
  const uids = getFieldUids({ curriculumProgramType });

  return {
    startDate,
    endDate,
    mode: state.post.postCreationMode,
    unitPlanId: _.get(unitPlan, "id", ""),
    templateId: _.get(unitPlan, "templateId", ""),
    resourceId: _.get(resourceItem, "id", ""),
    resourceType,
    attachments,
    courseId,
    isResourceSkipped,
    elementPYP,
    showLoaderBar: false,
    resourceItem,
    curriculumProgramType,
    courseUnitPlansIds,
    courseUnitPlans,
    unitPlanOptions,
    searchText: _.get(ownProps, "searchText", ""),
    t: ownProps.t,
    organizationId: _.get(state, "login.userInfo.org_id"),
    uids,
  };
};

const TagResourceWithHOC = compose(
  connect(null, mapActionCreators),

  graphql(getOrganizationAssessmentsQuery, {
    name: "getOrganizationAssessments",
    skip: props => _.isEmpty(_.get(props, "organizationId", "")),
    options: ({ organizationId, selectedUnitPlan, searchText, uids }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        first: 10,
        id: organizationId,
        filters: {
          units: selectedUnitPlan,
          searchText: searchText,
          types: groupType,
        },
        uids,
      },
    }),
    props: ({
      getOrganizationAssessments,
      ownProps: {
        resourceItem,
        organizationId,
        selectedUnitPlan,
        searchText,
        uids,
      },
    }) => {
      const edges = _.get(
        getOrganizationAssessments,
        "node.assessments.edges",
        0
      );
      const leCount = _.get(
        getOrganizationAssessments,
        "node.assessments.totalCount",
        0
      );
      const assessmentCount = 0;
      const resources = _.map(edges, item => {
        return { type: "ASSESSMENT", ...item.node };
      });

      return {
        hasNextPage: _.get(
          getOrganizationAssessments,
          "node.assessments.pageInfo.hasNextPage",
          false
        ),
        getOrganizationAssessments,
        leCount: leCount,
        assessmentCount: assessmentCount,
        resources: !_.isEmpty(resourceItem)
          ? _.uniqBy([resourceItem, ...resources], "id")
          : resources,
        isData: !!_.get(getOrganizationAssessments, "node", null),
        isLoading:
          getOrganizationAssessments["networkStatus"] == 1 ||
          getOrganizationAssessments["networkStatus"] == 2,
        networkStatus: getOrganizationAssessments["networkStatus"],
        loadMoreAssessments: () => {
          const endCursor = _.get(
            getOrganizationAssessments,
            "node.assessments.pageInfo.endCursor",
            false
          );
          return getOrganizationAssessments.fetchMore({
            variables: {
              first: 10,
              after: endCursor,
              id: organizationId,
              filters: {
                units: selectedUnitPlan,
                searchText: searchText,
                types: groupType,
              },
              uids,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              const previousAssessments = previousResult.node;
              const newAssessments = fetchMoreResult.node;
              return {
                ...previousResult,
                node: {
                  ...previousAssessments,
                  assessments: {
                    ...previousAssessments.assessments,
                    pageInfo: {
                      ...previousAssessments.assessments.pageInfo,
                      ...newAssessments.assessments.pageInfo,
                    },
                    edges: [
                      ..._.uniqBy(
                        [
                          ...previousAssessments.assessments.edges,
                          ...newAssessments.assessments.edges,
                        ],
                        item => _.get(item, "node.id")
                      ),
                    ],
                  },
                },
              };
            },
          });
        },
      };
    },
  }),
  // Skipping the following query, because if there are large number of assessments, the query will be time-out
  graphql(getResourceBucketQuery, {
    name: "getResourceBucket",
    skip: true,
    options: ({ selectedUnitPlan, searchText }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ids: selectedUnitPlan,
        type: "UNIT_PLAN",
        resourceFilters: {
          searchText: searchText,
        },
      },
    }),
    props: ({ getResourceBucket, ownProps: { resourceItem } }) => {
      const edges = [];
      let leCount = 0,
        assessmentCount = 0;
      _.forEach(_.get(getResourceBucket, "multiNode", []), unit => {
        const unitEdges = _.get(unit, "resourceLibrary.edges", []);
        leCount += _.get(unit, "resourceLibrary.leCount", 0);

        assessmentCount += _.get(unit, "resourceLibrary.assessmentCount", 0);
        edges.push(...unitEdges);
      });
      const resources = _.map(edges, item => {
        return { type: item.type, leCount, ...item.node };
      });

      return {
        getResourceBucket,
        leCount: leCount,
        assessmentCount: assessmentCount,
        resources: !_.isEmpty(resourceItem)
          ? _.uniqBy([resourceItem, ...resources], "id")
          : resources,
        isData: !!_.get(getResourceBucket, "multiNode", null),
        isLoading:
          getResourceBucket["networkStatus"] == 1 ||
          getResourceBucket["networkStatus"] == 2,
      };
    },
  })
)(TagResource);
class TagResourcesWrapper extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      selectedUnitPlan: _.get(props, "courseUnitPlansIds", ""),
    };
  }

  updateSearchText = value => {
    this.setState({ searchText: value });
  };

  onUnitPlanFilterChanged = value => {
    this.setState({ selectedUnitPlan: value });
  };

  render() {
    return (
      <TagResourceWithHOC
        {...this.props}
        searchText={this.state.searchText}
        updateSearchText={this.updateSearchText}
        selectedUnitPlan={this.state.selectedUnitPlan}
        onUnitPlanFilterChanged={this.onUnitPlanFilterChanged}
      />
    );
  }
}
export default compose(
  I18nHOC({ resource: "common" }),
  connect(mapStateToProps, null)
)(TagResourcesWrapper);
